<template>
  <el-dialog
    :title="$t('components.DialogReportQuestion.119050-0')"
    :visible.sync="dialogVisible"
    width="600px"
    @close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form :model="formData" :rules="rules" ref="reportForm" label-width="100px">
      <el-form-item :label="$t('components.DialogReportQuestion.119050-1')" prop="userEquipmentId">
        <el-select
          v-model="formData.userEquipmentId"
          filterable
          remote
          reserve-keyword
          :placeholder="$t('components.DialogReportQuestion.119050-2')"
          :remote-method="remoteMethod"
          :loading="loading"
          v-el-select-loadmore="loadMore"
        >
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.id"> </el-option>
          <p v-if="loading" class="el-select-dropdown__item load-more">
            {{ $t("components.DialogReportQuestion.991604-0") }}
          </p>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('components.DialogReportQuestion.119050-5')" prop="questionType">
        <el-select v-model="formData.questionType" :placeholder="$t('components.DialogReportQuestion.119050-6')">
          <el-option :value="1" :label="$t('components.DialogReportQuestion.119050-7')"></el-option>
          <el-option :value="2" :label="$t('components.DialogReportQuestion.119050-8')"></el-option>
          <el-option :value="3" :label="$t('components.DialogReportQuestion.119050-9')"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('components.DialogReportQuestion.119050-10')" prop="description">
        <el-input
          type="textarea"
          v-model="formData.description"
          :placeholder="$t('components.DialogReportQuestion.119050-11')"
          :rows="4"
        >
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('components.DialogReportQuestion.119050-12')" style="position: relative">
        <div v-if="uploadLoading" style="position: absolute; top: 0; left: 0; bottom: 0; right: 0"></div>
        <el-upload
          ref="upload"
          action="#"
          :http-request="customUploadFile"
          :before-upload="beforeUpload"
          :on-remove="handleRemove"
          :file-list="fileList"
          :limit="2"
          accept=".jpg,.jpeg,.png,.mp4"
        >
          <el-button size="small" :loading="uploadLoading" type="primary">
            {{
              uploadLoading
                ? $t("components.DialogReportQuestion.268740-0")
                : $t("components.DialogReportQuestion.119050-13")
            }}
          </el-button>
          <div slot="tip" class="el-upload__tip">{{ $t("components.DialogReportQuestion.119050-14") }}</div>
        </el-upload>
      </el-form-item>
      <el-form-item :label="$t('components.DialogReportQuestion.119050-15')" prop="priority">
        <el-select v-model="formData.priority" :placeholder="$t('components.DialogReportQuestion.119050-16')">
          <el-option :value="0" :label="$t('components.DialogReportQuestion.119050-17')"></el-option>
          <el-option :value="1" :label="$t('components.DialogReportQuestion.119050-18')"></el-option>
          <el-option :value="2" :label="$t('components.DialogReportQuestion.119050-19')"></el-option>
          <el-option :value="3" :label="$t('components.DialogReportQuestion.119050-20')"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t("components.DialogReportQuestion.119050-21") }}</el-button>
      <el-button type="primary" :disabled="uploadLoading" @click="submitForm" :loading="submitLoading">
        {{ $t("components.DialogReportQuestion.119050-22") }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "DialogReportQuestion",
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    directives: {
      "el-select-loadmore": {
        bind(el, binding) {
          const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
          SELECTWRAP_DOM.addEventListener("scroll", function () {
            const condition = this.scrollHeight - this.scrollTop - 15 <= this.clientHeight;
            if (condition) {
              binding.value();
            }
          });
        }
      }
    },
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        loading: false,
        options: [],
        queryString: "",
        timeout: null,
        pageIndex: 1,
        pageSize: 30,
        hasMore: true,
        formData: {
          equipmentNo: "",
          equipmentName: "",
          description: "",
          priority: 0,
          questionType: 1,
          fileUrls: [],
          userEquipmentId: []
        },
        fileList: [],
        rules: {
          userEquipmentId: [
            { required: true, message: this.$t("components.DialogReportQuestion.966723-0"), trigger: "change" }
          ],
          questionType: [
            { required: true, message: this.$t("components.DialogReportQuestion.119050-6"), trigger: "change" }
          ],
          description: [
            { required: true, message: this.$t("components.DialogReportQuestion.119050-11"), trigger: "blur" }
          ]
        },
        uploadLoading: false
      };
    },
    watch: {
      visible(val) {
        this.dialogVisible = val;
      },
      dialogVisible(val) {
        if (!val) {
          this.$emit("update:visible", false);
        }
      }
    },
    methods: {
      remoteMethod(query) {
        if (query !== "") {
          this.queryString = query;
          this.pageIndex = 1;
          this.hasMore = true;

          // 防抖处理
          if (this.timeout) {
            clearTimeout(this.timeout);
          }

          this.timeout = setTimeout(() => {
            this.loading = true;
            this.options = [];
            this.fetchMachineList(query);
          }, 300);
        } else {
          this.options = [];
        }
      },

      fetchMachineList(query) {
        if (!this.hasMore) return;

        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          searchName: query
        };

        // 保存当前页码，避免异步问题
        const currentRequestPage = this.pageIndex;

        this.$api
          .request(this.$url.WorkOrder.userMachineSelect, this.$method.get, params)
          .then(res => {
            if (res.code === 0 && res.data) {
              const newData = res.data.records || [];
              const newOptions = newData.map(item => ({
                value: item.id,
                label: `${item.equipmentNo} - ${item.name}`,
                id: item.id
              }));

              // 如果是第一页，替换全部数据；否则追加数据
              if (currentRequestPage === 1) {
                this.options = newOptions;
              } else {
                // 追加数据而不是替换
                this.options = [...this.options, ...newOptions];
              }

              // 判断是否还有更多数据
              if (newData.length < this.pageSize) {
                this.hasMore = false;
              }
            } else {
              this.$message.error(res.msg || this.$t("components.DialogReportQuestion.991604-2"));
            }
            // 设置loading状态为false
            this.loading = false;
          })
          .catch(err => {
            console.error(this.$t("components.DialogReportQuestion.991604-3"), err);
            this.$message.error(this.$t("components.DialogReportQuestion.991604-2"));
            this.loading = false;
          });
      },

      // 加载更多数据
      loadMore() {
        if (this.loading || !this.hasMore || !this.queryString) return;

        this.loading = true;
        this.pageIndex += 1;
        this.fetchMachineList(this.queryString);
      },

      handleClose() {
        this.resetForm();
      },
      resetForm() {
        this.$refs.reportForm && this.$refs.reportForm.resetFields();
        this.fileList = [];
        this.formData.fileUrls = [];
      },
      beforeUpload(file) {
        const isImage = file.type.startsWith("image/");
        const isVideo = file.type === "video/mp4";
        const isValidType = isImage || isVideo;
        const isLt10M = file.size / 1024 / 1024 < 10;

        if (!isValidType) {
          this.$message.error(this.$t("components.DialogReportQuestion.119050-23"));
          return false;
        }
        if (!isLt10M) {
          this.$message.error(this.$t("components.DialogReportQuestion.119050-24"));
          return false;
        }
        return true;
      },
      customUploadFile(options) {
        // 使用真实的上传接口
        const { file } = options;
        const formData = new FormData();
        formData.append("file", file);
        const isVideo = file && file.type && file.type.startsWith("video");
        const uploadUrl = isVideo ? this.$url.WorkOrder.uploadVideo : this.$url.WorkOrder.uploadImg;
        this.uploadLoading = true;
        this.$api
          .request(uploadUrl, this.$method.post, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(res => {
            if (res.code === 0 && res.data) {
              // 如果上传成功，将返回的URL添加到fileUrls数组
              this.formData.fileUrls.push(res.data);
              options.onSuccess && options.onSuccess({ url: res.data });
              this.$message.success(this.$t("components.DialogReportQuestion.119050-25"));
            } else {
              options.onError &&
                options.onError(new Error(res.msg || this.$t("components.DialogReportQuestion.119050-26")));
              this.$message.error(res.msg || this.$t("components.DialogReportQuestion.119050-27"));
            }
          })
          .catch(err => {
            console.error(this.$t("components.DialogReportQuestion.119050-28"), err);
            options.onError && options.onError(err);
            this.$message.error(this.$t("components.DialogReportQuestion.119050-27"));
          })
          .finally(() => {
            this.uploadLoading = false;
          });
      },
      handleRemove(file, fileList) {
        this.fileList = fileList;
        // 从fileUrls中移除
        const fileUrl = file.url || file.response?.url;
        if (fileUrl) {
          const index = this.formData.fileUrls.indexOf(fileUrl);
          if (index !== -1) {
            this.formData.fileUrls.splice(index, 1);
          }
        }
      },
      submitForm() {
        this.$refs.reportForm.validate(valid => {
          if (valid) {
            this.submitLoading = true;

            // 构造请求参数
            const params = {
              userEquipmentId: this.formData.userEquipmentId, // 使用设备号作为设备ID
              questionType: this.formData.questionType,
              priority: this.formData.priority,
              description: this.formData.description,
              fileUrls: this.formData.fileUrls
            };

            // 调用创建工单API
            this.$api
              .request(this.$url.WorkOrder.insert, this.$method.post, params)
              .then(res => {
                this.submitLoading = false;
                if (res.code === 0) {
                  this.$message.success(this.$t("components.DialogReportQuestion.119050-29"));
                  this.dialogVisible = false;
                  this.resetForm();
                  this.$emit("refresh"); // 通知父组件刷新列表
                } else {
                  this.$message.error(res.msg || this.$t("components.DialogReportQuestion.119050-30"));
                }
              })
              .catch(err => {
                console.error(this.$t("components.DialogReportQuestion.119050-31"), err);
                this.$message.error(this.$t("components.DialogReportQuestion.119050-30"));
                this.submitLoading = false;
              });
          } else {
            return false;
          }
        });
      }
    }
  };
</script>

<style scoped>
  .el-upload__tip {
    line-height: 1.2;
    margin-top: 5px;
    color: #909399;
  }

  .load-more {
    text-align: center;
    color: #409eff;
    cursor: pointer;
    padding: 8px 0;
    font-size: 14px;
    border-top: 1px solid #ebeef5;
  }

  .load-more:hover {
    background-color: #f5f7fa;
  }
</style>
